import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import CourseCodes from "AppComponents/AdminNavigation/routes/CourseCodes";
import AcademicCourseCodes from "AppComponents/AdminNavigation/routes/AcademicCourseCodes";

export default store => ({
  path: "course-codes",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "course-codes" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
  childRoutes: [AcademicCourseCodes(store), CourseCodes(store)],
});
